 import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import User, { IUser } from "../../services/api/User";
import Button from "../../components/Form/Button";
import Checkbox from "../../components/Form/Checkbox";
import Form from "./components/Form";
import Group, { IGroup } from "../../services/api/Group";
import Profile, { IProfile } from "../../services/api/Profile";

import UserList from "./components/UserList";
import ContentHeader from "../../components/ContentHeader";

import { ReactComponent as UsersLogo } from "../../components/ContentHeader/assets/images/users.svg";
import Loading from "../../components/Loading";

import "./assets/css/style.css";

const Users: React.FC = () => {
  const { user } = useContext(AuthContext);
  const readOnly = user!.profile.name === "Viewer";

  const [users, setUsers] = useState<IUser[]>([]);
  const [profiles, setProfiles] = useState<IProfile[]>([]);
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);
  const [showActive, setShowActive] = useState<Boolean>(true);

  useEffect(() => {
    Promise.all([User.GetAll(), Group.GetAll(), Profile.GetAll()])
      .then((value) => {
        setUsers(value[0]);
        setGroups(value[1]);
        setProfiles(value[2]);
        isLoading(false);
      })
      .catch(console.log);
  }, []);

  function toggleForm(e: any) {
    e.target.nextElementSibling.classList.toggle("form--open");
    e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
      "form--open"
    );
  }

  return (
    <main className="wrapperApp">
      <ContentHeader title="Users" Icon={UsersLogo} breadcrumb={["Users"]} />
      <div id="content">
        <section className="content__block">
          <div className="content__header">
            <h2 className="content__title">Create or edit users</h2>
            <div className="content__select content__select--show-users">
              <Checkbox                  
                  id={'displayUsers'}
                  //disabled={readOnly}
                  title="Active users"
                  name="active"
                  value="true"
                  checked={showActive}
                  handleChange={(evt:any) => {setShowActive(evt.target.checked);}}
                />
            </div>
            <div className="content__select">
              {readOnly ? null : (
                <Button
                  onClick={toggleForm}
                  className="button button--blue button--icon button--add"
                  title="Add New"
                />
              )}
              <div className="form--float">
                <Form
                  userEdit={{} as IUser}
                  profiles={profiles}
                  groups={groups}
                />
              </div>
            </div>
          </div>

          <div className="users-container">
            <div className="users-container__options">
              <div className="users-container__select">{/* SELECTS */}</div>
              {/* <form className="form search">
                <input
                  className="form__input form__input--search"
                  type="search"
                  name="search"
                  id="search"
                  placeholder="Search User"
                />
                <button className="form__button--search"></button>
              </form> */}
            </div>
            {loading ? (
              <Loading />
            ) : (
              <React.Fragment>
                <UserList data={users.filter((value:IUser) => { return showActive === value.active })} profiles={profiles} groups={groups} />
              </React.Fragment>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default Users;
